import type { TFunction } from 'i18next';

import type { ErrorMessageTypes } from '../components/alerts/errors/error-map';

/**
 * Get error message text from error type
 * @param t - Translation function from i18next
 * @param errorType - The error type
 * @param remainingAttempts - Optional remaining attempts count
 * @returns The error message string or undefined
 */
export const getErrorMessage = (
    t: TFunction,
    errorType?: ErrorMessageTypes,
    remainingAttempts?: number
): string | undefined => {
    if (!errorType) return undefined;

    switch (errorType) {
        case '400_InvalidCode':
            if (remainingAttempts !== undefined && remainingAttempts > 0) {
                const key =
                    remainingAttempts === 1
                        ? 'formErrors.invalidCodeError.withOneAttempt'
                        : 'formErrors.invalidCodeError.withAttempts';
                return t(key, {
                    attempts: remainingAttempts,
                });
            }
            return t('formErrors.invalidCodeError.tryAgain');
        case '404_CodeExpired':
            return t('formErrors.codeExpiredError.requestNew');
        case '429_MaxAttemptReached':
            return t('formErrors.maxAttemptsReachedError.tryAgain');
        default:
            return t('formErrors.genericErrorMessage.errorOccured');
    }
};
